export default __webpack_public_path__ + "static/media/pan-left.ce25fe32.svg";